<div class="review-reminder">
  <div class="reminder-row">

    <div class="ui-g p-0">
      <div class="ui-g-12 p-0">
        <div id="review-toggle-datetime-{{id}}{{index}}"
          class="reminder-heading flex-between-center pb-1 b-bottom-gray-85 pointer" (click)="toggle('datetime')">
          <span>Reminder {{index}}</span>
          <div class="fal fa-chevron-down"></div>
        </div>

        <div class="flex-between-center mb-1">
          <span class="font-11 truncate-inline w-50">
            {{selectedTime?.label}} {{reminderDayText[selectedDay?.value]}}
          </span>
          <span id="review-toggle-message-{{id}}{{index}}" class="font-primary pointer font-11"
            (click)="toggle('message')">
            Customize message
          </span>
        </div>

        <div class="ui-g-12 p-0" *ngIf="visible.datetime">
          <div class="ui-g-5 p-0 flex-column">
            <span>Time</span>
            <app-dropdown id="d-review-time-{{id}}{{index}}" listId="d-review-time-list-{{id}}{{index}}" theme="border"
              field="label" [options]="timeOptions" [value]="selectedTime"
              (appSelect)="handleSelect('selectedTime', 'time',  $event)"></app-dropdown>
          </div>

          <div class="ui-g-5 p-0 pl-2 flex-column">
            <span>Day</span>
            <app-dropdown id="d-review-day-{{id}}{{index}}" listId="d-review-day-list-{{id}}{{index}}" theme="border"
              field="label" [options]="dayOptions" [value]="selectedDay"
              (appSelect)="handleSelect('selectedDay', 'day', $event)"></app-dropdown>
          </div>
        </div>

        <div class="ui-g-12 p-0 mt-1" *ngIf="visible.message">
          <app-textarea textAreaId="review-cutomize-message-{{id}}{{index}}" placeholder="Message" theme="border"
            [fontSize]="12" [value]="reminder.message" [rows]="3" (appChange)="handleChange('message', $event)">
          </app-textarea>
        </div>
      </div>
    </div>
  </div>
</div>
